import { Injectable, inject } from "@angular/core";

import { AnalyticsService, EVENT_UAEVENT } from "@hermes/fragments/analytics";

interface ClickCategoryPosterEventData {
    eventaction: string;
    eventlabel: string;
}

@Injectable()
export class CategoryPosterAnalyticsService {
    private analyticsService = inject(AnalyticsService);

    public sendUAEvent(eventData: ClickCategoryPosterEventData): void {
        this.analyticsService.sendRawData({
            event: EVENT_UAEVENT,
            eventcategory: "Module_CategoryHighlight",
            eventaction: eventData.eventaction,
            eventlabel: eventData.eventlabel,
        });
    }
}
